import React from 'react';

import Button from '@material-ui/core/Button';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import Modal from '@material-ui/core/Modal';
import Paper from '@material-ui/core/Paper';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import CircularProgress from '@material-ui/core/CircularProgress';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItemSelect from '@material-ui/core/MenuItem';

import SaveIcon from '@material-ui/icons/Save';
import EditIcon from '@material-ui/icons/Edit';
import CloseIcon from '@material-ui/icons/Close';
import DescriptionIcon from '@material-ui/icons/Description';
import RefreshIcon from '@material-ui/icons/Refresh';
import DeleteIcon from '@material-ui/icons/Delete';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import ShareIcon from '@material-ui/icons/Share';
import CancelIcon from '@material-ui/icons/Cancel';
import UndoIcon from '@material-ui/icons/Undo';

import Moment from 'moment';

export default function Header(props) {
  const { ctx, res, profile, classes, link } = props;
  const readOnly = !ctx.state.editForm;

  const menuAnchorEl = ctx.state.menuAnchorEl;
  const menuOpen = Boolean(menuAnchorEl);

  const handleOpenActionsMenu = (event) => {
    ctx.setState({ menuAnchorEl: event.currentTarget });
  };

  const handleCloseActionsMenu = () => {
    ctx.setState({ menuAnchorEl: null });
  };

  const isOriginCompany = ctx.state.companyID === ctx.state.companyOriginID;
  const shareStatus = ctx.state.share_status;

  const canShare =
    isOriginCompany &&
    shareStatus === 'criado' &&
    !ctx.state.sendingShare;

  const canCancelShare =
    isOriginCompany &&
    shareStatus === 'compartilhado' &&
    !ctx.state.sendingCancel;

  const canReturn =
    !isOriginCompany &&
    shareStatus === 'compartilhado' &&
    !ctx.state.sendingReturn &&
    Number(ctx.state.list_exe_return) !== 0;

  const handleShare = () => {
    handleCloseActionsMenu();
    if (!canShare) return;
    if (ctx.openShareModal) {
      ctx.openShareModal();
    } else if (ctx.setState) {
      ctx.setState({ shareModalOpen: true });
    }
  };

  const handleCancelShare = () => {
    handleCloseActionsMenu();
    if (!canCancelShare) return;
    if (ctx.setState) {
      ctx.setState({ openCancelConfirm: true });
    }
  };

  const handleReturnServiceOrder = () => {
    handleCloseActionsMenu();
    if (!canReturn) return;
    if (ctx.setState) {
      ctx.setState({ openReturnConfirm: true });
    }
  };

  return (
    <>
      <div className="containerTop">
        <div><h1>{res.ORDEM_SERVICO}</h1></div>

        <div className="centerTop" style={{ display: 'flex', justifyContent: 'center' }}>
          <Tabs
            value={ctx.state.tabValue}
            onChange={ctx.handleChangeTab}
            TabIndicatorProps={{ style: { display: 'none' } }}
            sx={{
              backgroundColor: '#2c2c2c',
              borderRadius: '20px',
              padding: '4px',
              minHeight: 'unset'
            }}
          >
            {[
              { label: res.CLIENTE },
              { label: res.SERVICO },
              { label: res.FINANCEIRO },
              // { label: res.FINANCEIRO, disabled: !profile.includes(2) ? true : false },
              { label: res.ASSINATURA },
              { label: res.ANEXOS }
            ].map((tab, index) => (
              <Tab
                key={index}
                label={tab.label}
                disabled={!!tab.disabled}
                style={{
                  display: 'flex',
                  textTransform: 'uppercase',
                  fontSize: '0.8rem',
                  fontWeight: 'bold',
                  borderRadius: '1rem',
                  minHeight: 'unset',
                  padding: '0.25rem 1rem',
                  color: ctx.state.tabValue === index ? '#fff' : !tab.disabled ? 'black' : '#b0b0b0',
                  backgroundColor: ctx.state.tabValue === index ? '#3f51b5' : 'transparent',
                }}
              />
            ))}
          </Tabs>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column' }}>
          {readOnly && (
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '0.5rem', gap: '0.5rem' }}>
              {ctx.state.guidDocument ? (
                <Button
                  variant="contained"
                  onClick={ctx.handleOpenModal}
                  className="popUpButton"
                >
                  {res.ACOMPANHAR_ASSINATURA}
                </Button>
              ) : (
                <Button
                  variant="contained"
                  className="popUpButton"
                  onClick={ctx.downloadRelServiceOrder}
                  color={ctx.state.reportGenerated ? "default" : "primary"}
                  disabled={
                    ctx.state.reportGenerated ||
                    ctx.state.isGeneratingReport ||
                    !ctx.state.serviceOrderData
                  }
                >
                  {ctx.state.reportGenerated ? (
                    <CircularProgress size={24} />
                  ) : (
                    <>
                      <DescriptionIcon className="iconMapS" />
                      {res.GERAR_RELATORIO}
                    </>
                  )}
                </Button>
              )}

              <Button
                color="primary"
                variant="contained"
                className="popUpButton"
                aria-label="ações da ordem de serviço"
                onClick={handleOpenActionsMenu}
              >
                <MoreVertIcon />
              </Button>

              <Menu
                anchorEl={menuAnchorEl}
                keepMounted
                open={menuOpen}
                onClose={handleCloseActionsMenu}
              >
                <MenuItem onClick={handleShare} disabled={!canShare}>
                  <ListItemIcon>
                    <ShareIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText primary={res.COMPARTILHAMENTO} />
                </MenuItem>

                <MenuItem onClick={handleCancelShare} disabled={!canCancelShare}>
                  <ListItemIcon>
                    <CancelIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText primary={res.CANCELAR_COMPARTILHAMENTO} />
                </MenuItem>

                <MenuItem onClick={handleReturnServiceOrder} disabled={!canReturn}>
                  <ListItemIcon>
                    <UndoIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText primary={res.RETORNAR_ORDEM_SERVICO} />
                </MenuItem>
              </Menu>
            </div>
          )}

          {ctx.state.editForm ? (
            !ctx.state.modalOpen && !ctx.state.financeEditOpen && (
              <Button
                onClick={ctx.salvarTrabalho}
                style={{ width: '100%' }}
                variant="contained"
                color="primary"
                className="popUpButton"
              >
                <SaveIcon className="iconMapS" />
                {res.SALVAR}
              </Button>
            )
          ) : (
            <div style={{ display: 'flex', gap: '0.5rem' }}>
              <Button
                variant="contained"
                onClick={() => { link('/app/ordem-servico/list'); }}
                className="popUpButton"
                style={{ width: '50%' }}
              >
                {res.CANCELAR}
              </Button>
              <Button
                onClick={ctx.openEditForm}
                disabled={
                  ctx.state.companyID === ctx.state.companyOriginID
                    ? !(ctx.state.share_status === 'criado' || ctx.state.share_status === 'retornado')
                    : ctx.state.share_status !== 'compartilhado'
                }
                variant="contained"
                color="primary"
                className="popUpButton"
                style={{ width: '50%' }}
              >
                <EditIcon className="iconMapS" />
                {res.EDITAR}
              </Button>
            </div>
          )}
        </div>
      </div>

      <Modal
        open={ctx.state.openModal}
        onClose={ctx.handleCloseModal}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      >
        <Paper style={{ maxWidth: '80%', overflow: 'auto' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', backgroundColor: '#2D3238', padding: '0.5rem 0' }}>
            <div style={{ width: '33%', textAlign: 'left' }}></div>
            <div style={{ width: '33%', textAlign: 'center' }}>
              <h2 style={{ color: 'white' }}>{res.DADOS_DOCUMENTO}</h2>
            </div>
            <div style={{ width: '33%', textAlign: 'right' }}>
              <Button size="small" className="popUpButton" onClick={ctx.handleCloseModal}>
                <CloseIcon style={{ color: 'white' }} />
              </Button>
            </div>
          </div>

          <div style={{ display: 'flex', justifyContent: 'right', padding: '1rem' }}>
            {ctx.state.allSigned && (
              <Button
                variant="contained"
                color="primary"
                className="popUpButton"
                onClick={() => ctx.downloadReportSigned(
                  undefined,
                  `Relatorio-OS-${ctx.state.serviceOrder || ''}-assinado.pdf`
                )}
                disabled={
                  !(ctx.state && (ctx.state.fileSigned || (ctx.state.signature && ctx.state.signature.file_signed)))
                }
                style={{ paddingTop: '0.75rem' }}
              >
                <DescriptionIcon className="iconMapS" />
                {res.BAIXAR_RELATORIO}
              </Button>
            )} &nbsp;
            <Button variant="contained" color="primary" className="popUpButton" onClick={ctx.readServiceOrderById} style={{ paddingTop: '0.75rem' }}>
              <RefreshIcon className="iconMapS" />
            </Button> &nbsp;
            <Button
              variant="contained"
              style={{ backgroundColor: 'red', color: 'white', paddingTop: '0.75rem' }}
              className="popUpButton"
              onClick={ctx.openDeleteConfirm}
            >
              <DeleteIcon className="iconMapS" />
            </Button>

            <Dialog open={ctx.state.docDeleteConfirmOpen} onClose={ctx.closeDeleteConfirm}>
              <DialogTitle style={{ padding: 0 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', backgroundColor: '#2D3238', padding: '0.5rem 0' }}>
                  <div style={{ width: '100%' }} />
                  <div style={{ width: '100%', whiteSpace: 'nowrap' }}>
                    <p style={{ color: 'white', margin: 0 }}>{res.EXCLUIR_DOCUMENTO}</p>
                  </div>
                  <div style={{ width: '100%', textAlign: 'right' }}>
                    <Button size="small" className="popUpButton" onClick={ctx.closeDeleteConfirm}>
                      <CloseIcon style={{ color: 'white' }} />
                    </Button>
                  </div>
                </div>
              </DialogTitle>
              <DialogContent>
                <div style={{ color: 'black' }}>{res.CONFIRMAR_EXCLUSÃO}</div>
              </DialogContent>
              <DialogActions>
                <Button onClick={ctx.closeDeleteConfirm} color="primary">{res.NAO}</Button>
                <Button onClick={ctx.handleDeleteSignature} color="primary" autoFocus>{res.SIM}</Button>
              </DialogActions>
            </Dialog>
          </div>

          <Table>
            <TableHead>
              <TableRow>
                <TableCell style={{ whiteSpace: 'nowrap', textAlign: 'center' }}>{res.NOME}</TableCell>
                <TableCell style={{ whiteSpace: 'nowrap', textAlign: 'center' }}>{res.E_MAIL}</TableCell>
                <TableCell style={{ whiteSpace: 'nowrap', textAlign: 'center' }}>{res.FUNCAO}</TableCell>
                <TableCell style={{ whiteSpace: 'nowrap', textAlign: 'center' }}>{res.ETAPA}</TableCell>
                <TableCell style={{ whiteSpace: 'nowrap', textAlign: 'center' }}>{res.STATUS_ASSINATURA}</TableCell>
                <TableCell style={{ whiteSpace: 'nowrap', textAlign: 'center' }}>{res.ULTIMA_ATUALIZACAO}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {Array.isArray(ctx.state.documentParts) && ctx.state.documentParts.length > 0 ? (
                ctx.state.documentParts.map((part) => {
                  const { icon, etapa, date } = ctx.getStatusDetails(part);
                  const nome = part.nome || ctx.getNameFromEmail(part.email) || '—';
                  const funcao = ctx.getFunctionFromEmail(part.email);
                  return (
                    <TableRow key={part.uuid || part.email}>
                      <TableCell style={{ whiteSpace: 'nowrap', textAlign: 'center' }}>{nome}</TableCell>
                      <TableCell style={{ whiteSpace: 'nowrap', textAlign: 'center' }}>{part.email || '—'}</TableCell>
                      <TableCell style={{ whiteSpace: 'nowrap', textAlign: 'center' }}>{funcao}</TableCell>
                      <TableCell style={{ whiteSpace: 'nowrap', textAlign: 'center' }}>{etapa || '—'}</TableCell>
                      <TableCell style={{ whiteSpace: 'nowrap', textAlign: 'center' }}>{icon}</TableCell>
                      <TableCell style={{ whiteSpace: 'nowrap', textAlign: 'center' }}>
                        {date ? Moment(date).format('DD/MM/YYYY HH:mm') : '—'}
                      </TableCell>
                    </TableRow>
                  );
                })
              ) : (
                <TableRow>
                  <TableCell colSpan={6} align="center">
                    {res.NENHUM_DADO}
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </Paper>
      </Modal>

      <Dialog
        open={!!ctx.state.shareModalOpen}
        onClose={() => ctx.setState({ shareModalOpen: false })}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle style={{ padding: 0 }}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              backgroundColor: '#2D3238',
              padding: '0.5rem 0'
            }}
          >
            <div style={{ width: '16%', textAlign: 'left' }} />

            <div style={{ textAlign: 'center' }}>
              <p style={{ color: 'white', margin: 0 }}>
                {res.COMPARTILHAMENTO}
              </p>
            </div>

            <div style={{ width: '16%', textAlign: 'right' }}>
              <Button
                size="small"
                className="popUpButton"
                onClick={() => ctx.setState({ shareModalOpen: false })}
              >
                <CloseIcon style={{ color: 'white' }} />
              </Button>
            </div>
          </div>
        </DialogTitle>

        <DialogContent style={{ background: 'white' }}>
          {ctx.state.loadingShareList && (
            <DialogContentText style={{ color: 'black' }}>
              {res.CARREGANDO}
            </DialogContentText>
          )}

          {!ctx.state.loadingShareList && ctx.state.dataShare.length === 0 && (
            <DialogContentText style={{ color: 'black' }}>
              {res.SEM_EMPRESA_COMPARTILHAMENTO}
            </DialogContentText>
          )}

          {!ctx.state.loadingShareList && ctx.state.dataShare.length > 0 && (
            <FormControl fullWidth style={{ marginTop: '1rem' }}>
              <InputLabel>
                {res.SELECIONE_CLIENTE}
              </InputLabel>
              <Select
                value={ctx.state.selectedShareCompanyId || ''}
                onChange={ctx.handleSelectShareCompany}
              >
                <MenuItemSelect value="" disabled>
                  <em>{res.SELECIONE}</em>
                </MenuItemSelect>
                {ctx.state.dataShare.map((item) => (
                  <MenuItemSelect
                    key={item.id}
                    value={item.id_company_linked}
                  >
                    {item.company_name}
                  </MenuItemSelect>
                ))}
              </Select>
            </FormControl>
          )}
        </DialogContent>

        <DialogActions style={{ background: 'white' }}>
          <Button
            onClick={() => ctx.setState({ shareModalOpen: false })}
            color="primary"
          >
            {res.CANCELAR}
          </Button>
          <Button
            onClick={ctx.sendShareServiceOrder}
            color="primary"
            variant="contained"
            disabled={
              !ctx.state.selectedShareCompanyId || ctx.state.sendingShare
            }
          >
            {ctx.state.sendingShare
              ? (res.PROCESSANDO)
              : (res.ENVIAR)}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={!!ctx.state.openReturnConfirm}
        onClose={() => ctx.setState({ openReturnConfirm: false })}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle style={{ padding: 0 }}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              backgroundColor: '#2D3238',
              padding: '0.5rem 0'
            }}
          >
            <div style={{ width: '16%', textAlign: 'left' }} />

            <div style={{ textAlign: 'center' }}>
              <p style={{ color: 'white', margin: 0 }}>
                {res.RETORNAR_ORDEM_SERVICO}
              </p>
            </div>

            <div style={{ width: '16%', textAlign: 'right' }}>
              <Button
                size="small"
                className="popUpButton"
                onClick={() => ctx.setState({ openReturnConfirm: false })}
              >
                <CloseIcon style={{ color: 'white' }} />
              </Button>
            </div>
          </div>
        </DialogTitle>

        <DialogContent style={{ background: 'white' }}>
          <DialogContentText style={{ color: 'black' }}>
            {res.CONFIMAR_RETORNO_ORDEM_SERVICO}
          </DialogContentText>
        </DialogContent>

        <DialogActions style={{ background: 'white' }}>
          <Button
            onClick={() => ctx.setState({ openReturnConfirm: false })}
            color="primary"
          >
            {res.CANCELAR}
          </Button>
          <Button
            onClick={() =>
              ctx.setState({ openReturnConfirm: false }, () =>
                ctx.sendReturnServiceOrder()
              )
            }
            color="primary"
            autoFocus
            disabled={ctx.state.sendingReturn}
          >
            {ctx.state.sendingReturn
              ? (res.PROCESSANDO)
              : (res.CONFIRMAR)}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={!!ctx.state.openCancelConfirm}
        onClose={() => ctx.setState({ openCancelConfirm: false })}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle style={{ padding: 0 }}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              backgroundColor: '#2D3238',
              padding: '0.5rem 0'
            }}
          >
            <div style={{ width: '16%', textAlign: 'left' }} />

            <div style={{ textAlign: 'center' }}>
              <p style={{ color: 'white', margin: 0 }}>
                {res.CANCELAR_COMPARTILHAMENTO}
              </p>
            </div>

            <div style={{ width: '16%', textAlign: 'right' }}>
              <Button
                size="small"
                className="popUpButton"
                onClick={() => ctx.setState({ openCancelConfirm: false })}
              >
                <CloseIcon style={{ color: 'white' }} />
              </Button>
            </div>
          </div>
        </DialogTitle>

        <DialogContent style={{ background: 'white' }}>
          <DialogContentText style={{ color: 'black' }}>
            {res.CONFIRMAR_CANCELAMENTO_COMPARTILHAMENTO}
          </DialogContentText>
        </DialogContent>

        <DialogActions style={{ background: 'white' }}>
          <Button
            onClick={() => ctx.setState({ openCancelConfirm: false })}
            color="primary"
          >
            {res.CANCELAR}
          </Button>
          <Button
            onClick={() =>
              ctx.setState({ openCancelConfirm: false }, () =>
                ctx.cancelShareServiceOrder()
              )
            }
            color="primary"
            autoFocus
            disabled={ctx.state.sendingCancel}
          >
            {ctx.state.sendingCancel
              ? (res.PROCESSANDO)
              : (res.CONFIRMAR)}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}